import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { MoreVertical, Eye, SquarePen, Trash, Copy } from 'lucide-react'

interface RowActionsMenuProps {
  source: 'ai' | 'manual'
  sourceQuote: string | null
  onViewSource?: () => void
  onEdit?: () => void
  onDelete?: () => void
}

export function RowActionsMenu({ source, sourceQuote, onViewSource, onEdit, onDelete }: RowActionsMenuProps) {
  const handleCopy = () => {
    if (sourceQuote) {
      void navigator.clipboard.writeText(sourceQuote)
    }
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label="Row actions"
          className="h-7 w-7 opacity-0 group-hover:opacity-100 transition-opacity"
        >
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {source === 'ai' && sourceQuote && (
          <DropdownMenuItem onClick={onViewSource}>
            <Eye className="h-4 w-4 mr-2" />
            View source quote
          </DropdownMenuItem>
        )}
        {sourceQuote && (
          <DropdownMenuItem onClick={handleCopy}>
            <Copy className="h-4 w-4 mr-2" />
            Copy source
          </DropdownMenuItem>
        )}
        {source === 'manual' && (
          <>
            <DropdownMenuSeparator />
            {onEdit && (
              <DropdownMenuItem onClick={onEdit}>
                <SquarePen className="h-4 w-4 mr-2" />
                Edit
              </DropdownMenuItem>
            )}
            {onDelete && (
              <DropdownMenuItem onClick={onDelete} className="text-destructive focus:text-destructive">
                <Trash className="h-4 w-4 mr-2" />
                Delete
              </DropdownMenuItem>
            )}
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
